import { Form_validators_enum } from "./form_validators_enum";

export const FORM_CONFIGS = Object.freeze({
  COMMISSIONING_DENY_REASON: {
    deny_reason: {
      type: "str",
      label: "Reason",
      defaultValue: "",
      required: false,
      validators: [Form_validators_enum.VALIDATE_MAX_LENGTH("reason", 250)],
    },
  },
  COMMISSIONING_COMMENTS: {
    comments: {
      type: "str",
      label: "Comments",
      defaultValue: "",
      required: true,
      validators: [
        Form_validators_enum.VALIDATE_REQUIRED("reason"),
        Form_validators_enum.VALIDATE_MAX_LENGTH("reason", 250),
      ],
    },
  },
  DRAFT_INSTALLATION_WITH_PARTNER_PRIVILEGE: {
    box_id: {
      type: "str",
      label: "Box ID",
      defaultValue: "",
      required: true,
      validators: [
        Form_validators_enum.VALIDATE_REQUIRED("Box ID"),
        Form_validators_enum.VALIDATE_FIXED_LENGTH("Box ID", 12),
        Form_validators_enum.VALIDATE_ALPHA_NUMERIC("Box ID"),
        Form_validators_enum.VALIDATE_SMARTBOX_CLAIM("Box ID"),
      ],
    },
    is_debug: {
      type: "bool",
      label: "Is debug?",
      defaultValue: false,
      required: true,
      validators: [Form_validators_enum.VALIDATE_REQUIRED("Box ID")],
    },
    site_name: {
      type: "str",
      label: "Site name",
      defaultValue: "",
      required: true,
      validators: [
        Form_validators_enum.VALIDATE_REQUIRED("Site name"),
        Form_validators_enum.VALIDATE_MIN_LENGTH("Site name", 3),
        Form_validators_enum.VALIDATE_MAX_LENGTH("Site name", 50),
        Form_validators_enum.VALIDATE_ALPHA_NUMERIC_SPACE_AND_UNDERSCORES("Site name"),
      ],
    },
    ean_1: {
      type: "str",
      label: "EAN code 1 - (Offtake/Injection)",
      defaultValue: "",
      required: false,
      validators: [
        Form_validators_enum.VALIDATE_STARTS_WITH("EAN 1", 54),
        Form_validators_enum.VALIDATE_NUMERIC("EAN 1"),
        Form_validators_enum.VALIDATE_FIXED_LENGTH("EAN 1", 18),
        Form_validators_enum.VALIDATE_CONNECTION_POINT_CLAIM("EAN 1"),
      ],
    },
    ean_2: {
      type: "str",
      label: "EAN code 2 - Optional - (Offtake/Injection)",
      defaultValue: "",
      required: false,
      validators: [
        Form_validators_enum.VALIDATE_STARTS_WITH("EAN 2", 54),
        Form_validators_enum.VALIDATE_NUMERIC("EAN 2"),
        Form_validators_enum.VALIDATE_FIXED_LENGTH("EAN 2", 18),
        Form_validators_enum.VALIDATE_CONNECTION_POINT_CLAIM("EAN 2"),
      ],
    },
  },
  DRAFT_INSTALLATION: {
    box_id: {
      type: "str",
      label: "Box ID",
      defaultValue: "",
      required: true,
      validators: [
        Form_validators_enum.VALIDATE_REQUIRED("Box ID"),
        Form_validators_enum.VALIDATE_FIXED_LENGTH("Box ID", 12),
        Form_validators_enum.VALIDATE_ALPHA_NUMERIC("Box ID"),
        Form_validators_enum.VALIDATE_SMARTBOX_CLAIM("Box ID"),
      ],
    },
    site_name: {
      type: "str",
      label: "Site name",
      defaultValue: "",
      required: true,
      validators: [
        Form_validators_enum.VALIDATE_REQUIRED("Site name"),
        Form_validators_enum.VALIDATE_MIN_LENGTH("Site name", 3),
        Form_validators_enum.VALIDATE_MAX_LENGTH("Site name", 50),
        Form_validators_enum.VALIDATE_ALPHA_NUMERIC_SPACE_AND_UNDERSCORES("Site name"),
      ],
    },
    ean_1: {
      type: "str",
      label: "EAN code 1 - (Offtake/Injection)",
      defaultValue: "",
      required: true,
      validators: [
        Form_validators_enum.VALIDATE_REQUIRED("EAN 1"),
        Form_validators_enum.VALIDATE_STARTS_WITH("EAN 1", 54),
        Form_validators_enum.VALIDATE_NUMERIC("EAN 1"),
        Form_validators_enum.VALIDATE_FIXED_LENGTH("EAN 1", 18),
        Form_validators_enum.VALIDATE_CONNECTION_POINT_CLAIM("EAN 1"),
      ],
    },
    ean_2: {
      type: "str",
      label: "EAN code 2 - Optional - (Offtake/Injection)",
      defaultValue: "",
      required: false,
      validators: [
        Form_validators_enum.VALIDATE_STARTS_WITH("EAN 2", 54),
        Form_validators_enum.VALIDATE_NUMERIC("EAN 2"),
        Form_validators_enum.VALIDATE_FIXED_LENGTH("EAN 2", 18),
        Form_validators_enum.VALIDATE_CONNECTION_POINT_CLAIM("EAN 2"),
      ],
    },
  },
  NEW_INSTALLATION: {
    box_id: {
      type: "str",
      label: "Box ID",
      defaultValue: "",
      required: true,
      validators: [
        Form_validators_enum.VALIDATE_REQUIRED("Box ID"),
        Form_validators_enum.VALIDATE_FIXED_LENGTH("Box ID", 12),
        Form_validators_enum.VALIDATE_ALPHA_NUMERIC("Box ID"),
        Form_validators_enum.VALIDATE_SMARTBOX_CLAIM("Box ID"),
      ],
    },
    site_name: {
      type: "str",
      label: "Site name",
      defaultValue: "",
      required: true,
      validators: [
        Form_validators_enum.VALIDATE_REQUIRED("Site name"),
        Form_validators_enum.VALIDATE_MIN_LENGTH("Site name", 3),
        Form_validators_enum.VALIDATE_MAX_LENGTH("Site name", 50),
        Form_validators_enum.VALIDATE_ALPHA_NUMERIC_SPACE_AND_UNDERSCORES("Site name"),
      ],
    },
  },
  LINK_TO_EXISTING_INSTALLATION: {
    site_name: {
      type: "str",
      label: "Site name [optional]",
      defaultValue: "",
      required: false,
      validators: [
        Form_validators_enum.VALIDATE_MIN_LENGTH("Site name", 3),
        Form_validators_enum.VALIDATE_MAX_LENGTH("Site name", 50),
        Form_validators_enum.VALIDATE_ALPHA_NUMERIC_SPACE_AND_UNDERSCORES("Site name"),
      ],
    },
  },
  REPLACE_SMARTBOX: {
    box_id: {
      type: "str",
      label: "Box ID",
      defaultValue: "",
      required: true,
      validators: [
        Form_validators_enum.VALIDATE_REQUIRED("Box ID"),
        Form_validators_enum.VALIDATE_FIXED_LENGTH("Box ID", 12),
        Form_validators_enum.VALIDATE_ALPHA_NUMERIC("Box ID"),
        Form_validators_enum.VALIDATE_SMARTBOX_CLAIM("Box ID"),
      ],
    },
  },
  RENAME_SITE: {
    site_name: {
      type: "str",
      label: "Site name",
      defaultValue: "",
      required: true,
      validators: [
        Form_validators_enum.VALIDATE_REQUIRED("Site name"),
        Form_validators_enum.VALIDATE_MIN_LENGTH("Site name", 3),
        Form_validators_enum.VALIDATE_MAX_LENGTH("Site name", 50),
        Form_validators_enum.VALIDATE_ALPHA_NUMERIC_SPACE_AND_UNDERSCORES("Site name"),
      ],
    },
  },
});
